import React, { useState } from "react";
import "../../Styles/AdminGalleryTable.css";
import { useNavigate } from "react-router-dom";

function AdminGalleryTable() {
  const navigate = useNavigate();

  const CATEGORIES = [
    "Leaders",
    "Events",
    "Spiritual",
    "Inaugurations",
    "Sports",
    "Others",
  ];

  const initialData = [
    {
      id: 1,
      title: "Meeting with Party Leaders",
      image: "https://picsum.photos/seed/gallery1/300/200",
      category: "Leaders",
      dateAdded: "20-07-2026",
      status: "Active",
      views: 320,
    },
    {
      id: 2,
      title: "Village Development Inauguration",
      image: "https://picsum.photos/seed/gallery2/300/200",
      category: "Inaugurations",
      dateAdded: "18-07-2026",
      status: "Active",
      views: 210,
    },
    {
      id: 3,
      title: "Government Welfare Event",
      image: "https://picsum.photos/seed/gallery3/300/200",
      category: "Events",
      dateAdded: "12-06-2026",
      status: "Active",
      views: 415,
    },
    {
      id: 4,
      title: "Temple Visit",
      image: "https://picsum.photos/seed/gallery4/300/200",
      category: "Spiritual",
      dateAdded: "05-06-2026",
      status: "Active",
      views: 180,
    },
    {
      id: 5,
      title: "District Sports Meet",
      image: "https://picsum.photos/seed/gallery5/300/200",
      category: "Sports",
      dateAdded: "28-05-2026",
      status: "Inactive",
      views: 96,
    },
    {
      id: 6,
      title: "Community Gathering",
      image: "https://picsum.photos/seed/gallery6/300/200",
      category: "Others",
      dateAdded: "22-05-2026",
      status: "Active",
      views: 142,
    },
  ];

  const [photos, setPhotos] = useState(initialData);

  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All Categories");
  const [status, setStatus] = useState("All Status");
  const [currentPage, setCurrentPage] = useState(1);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const totalPages = 5;

  const resetFilters = () => {
    setSearch("");
    setCategoryFilter("All Categories");
    setStatus("All Status");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // ---------- SEARCH + FILTER LOGIC ----------
  const filteredPhotos = photos.filter((item) => {
    const searchLower = search.trim().toLowerCase();

    const matchesSearch =
      searchLower === "" || item.title.toLowerCase().includes(searchLower);

    const matchesCategory =
      categoryFilter === "All Categories" || item.category === categoryFilter;

    const matchesStatus = status === "All Status" || item.status === status;

    return matchesSearch && matchesCategory && matchesStatus;
  });

  // ---------- EDIT LOGIC ----------
  const openEditModal = (item) => {
    setEditItem({ ...item });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditItem(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = (e) => {
    e.preventDefault();
    setPhotos((prev) =>
      prev.map((item) => (item.id === editItem.id ? editItem : item))
    );
    closeEditModal();
  };

  // ---------- STATS ----------
  const totalPhotos = photos.length;
  const totalCategories = new Set(photos.map((p) => p.category)).size;
  const totalViews = photos.reduce((sum, p) => sum + p.views, 0);

  const recentlyAdded = photos.filter((p) => {
    const today = new Date();
    const [day, month, year] = p.dateAdded.split("-").map(Number);
    return month === today.getMonth() + 1 && year === today.getFullYear();
  }).length;

  return (
    <div className="admingallery12-page">
      {/* Header */}
      <div className="admingallery12-header">
        <div className="admingallery12-header-left">
          <div className="admingallery12-page-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" strokeWidth="1.8" />
              <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <h2 className="admingallery12-title">Photo Gallery</h2>
            <p className="admingallery12-subtitle">
              Manage and organize all your gallery photos
            </p>
          </div>
        </div>

        <button
          className="admingallery12-add-btn"
          onClick={() => navigate("/AdminDashboard/AdminGalleryForm")}
        >
          <span className="admingallery12-add-icon">+</span> Add Photo
        </button>
      </div>

      {/* Stat Cards */}
      <div className="admingallery12-stats-grid">
        <div className="admingallery12-stat-card">
          <div className="admingallery12-stat-icon admingallery12-stat-icon-green">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" strokeWidth="1.8" />
              <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="admingallery12-stat-info">
            <span className="admingallery12-stat-label">Total Photos</span>
            <span className="admingallery12-stat-value">{totalPhotos}</span>
            <span className="admingallery12-stat-sub">All time photos</span>
          </div>
        </div>

        <div className="admingallery12-stat-card">
          <div className="admingallery12-stat-icon admingallery12-stat-icon-purple">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M4 6h16M4 12h16M4 18h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="admingallery12-stat-info">
            <span className="admingallery12-stat-label">Categories</span>
            <span className="admingallery12-stat-value">{totalCategories}</span>
            <span className="admingallery12-stat-sub">Active categories</span>
          </div>
        </div>

        <div className="admingallery12-stat-card">
          <div className="admingallery12-stat-icon admingallery12-stat-icon-orange">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </div>
          <div className="admingallery12-stat-info">
            <span className="admingallery12-stat-label">Recently Added</span>
            <span className="admingallery12-stat-value">{recentlyAdded}</span>
            <span className="admingallery12-stat-sub">This month</span>
          </div>
        </div>

        <div className="admingallery12-stat-card">
          <div className="admingallery12-stat-icon admingallery12-stat-icon-blue">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
              <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
            </svg>
          </div>
          <div className="admingallery12-stat-info">
            <span className="admingallery12-stat-label">Total Views</span>
            <span className="admingallery12-stat-value">
              {totalViews.toLocaleString()}
            </span>
            <span className="admingallery12-stat-sub">All time views</span>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="admingallery12-filters">
        <div className="admingallery12-search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
            <path d="M21 21l-4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search by photo title..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <select
          className="admingallery12-select"
          value={categoryFilter}
          onChange={(e) => {
            setCategoryFilter(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Categories</option>
          {CATEGORIES.map((cat) => (
            <option key={cat}>{cat}</option>
          ))}
        </select>

        <select
          className="admingallery12-select"
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        <button className="admingallery12-reset-btn" onClick={resetFilters}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path
              d="M4 4v6h6M20 20v-6h-6M4.5 15a8 8 0 0014.5 3.5M19.5 9A8 8 0 005 5.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Reset Filters
        </button>
      </div>

      {/* Table */}
      <div className="admingallery12-table-wrapper">
        <table className="admingallery12-table table table-hover">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Photo</th>
              <th>Category</th>
              <th>Date Added</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredPhotos.length === 0 ? (
              <tr>
                <td colSpan="6" className="admingallery12-no-data">
                  No photos found.
                </td>
              </tr>
            ) : (
              filteredPhotos.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>
                    <div className="admingallery12-photo-cell">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="admingallery12-thumb"
                      />
                      <span className="admingallery12-photo-title">
                        {item.title}
                      </span>
                    </div>
                  </td>

                  <td>
                    <span className="admingallery12-category-badge">
                      {item.category}
                    </span>
                  </td>

                  <td>
                    <div className="admingallery12-date-cell">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M3 10h18M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                      {item.dateAdded}
                    </div>
                  </td>

                  <td>
                    <span
                      className={`admingallery12-status-badge ${
                        item.status === "Active"
                          ? "admingallery12-status-active"
                          : "admingallery12-status-inactive"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="admingallery12-edit-btn"
                      onClick={() => openEditModal(item)}
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="admingallery12-pagination-bar">
        <span className="admingallery12-pagination-info">
          Showing 1 to {filteredPhotos.length} of {totalPhotos} photos
        </span>

        <div className="admingallery12-pagination-controls">
          <button
            className="admingallery12-page-arrow"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            &lt;
          </button>

          {[1, 2, 3].map((p) => (
            <button
              key={p}
              className={`admingallery12-page-num ${
                currentPage === p ? "admingallery12-active" : ""
              }`}
              onClick={() => handlePageChange(p)}
            >
              {p}
            </button>
          ))}

          <span className="admingallery12-page-dots">...</span>

          <button
            className={`admingallery12-page-num ${
              currentPage === totalPages ? "admingallery12-active" : ""
            }`}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>

          <button
            className="admingallery12-page-arrow"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            &gt;
          </button>
        </div>
      </div>

      {/* ---------------- EDIT MODAL ---------------- */}
      {showEditModal && editItem && (
        <div className="admingallery12-modal-overlay" onClick={closeEditModal}>
          <div className="admingallery12-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admingallery12-modal-header">
              <h3>Edit Photo</h3>
              <button className="admingallery12-modal-close" onClick={closeEditModal}>
                &times;
              </button>
            </div>

            <form className="admingallery12-modal-body" onSubmit={handleEditSave}>
              <div className="admingallery12-form-group">
                <label>Photo Title</label>
                <input
                  type="text"
                  name="title"
                  value={editItem.title}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="admingallery12-form-group">
                <label>Category</label>
                <select
                  name="category"
                  value={editItem.category}
                  onChange={handleEditChange}
                >
                  {CATEGORIES.map((cat) => (
                    <option key={cat}>{cat}</option>
                  ))}
                </select>
              </div>

              <div className="admingallery12-form-row">
                <div className="admingallery12-form-group">
                  <label>Date Added</label>
                  <input
                    type="text"
                    name="dateAdded"
                    placeholder="DD-MM-YYYY"
                    value={editItem.dateAdded}
                    onChange={handleEditChange}
                    required
                  />
                </div>

                <div className="admingallery12-form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={editItem.status}
                    onChange={handleEditChange}
                  >
                    <option>Active</option>
                    <option>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="admingallery12-modal-footer">
                <button
                  type="button"
                  className="admingallery12-btn-cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button type="submit" className="admingallery12-btn-save">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminGalleryTable;